import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="call-to-action" ref={ref} className="relative w-full overflow-hidden bg-primary transition-all duration-1000 ease-out opacity-100 translate-y-0 ![padding:80px_0px_80px_0px]">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
      backgroundImage: `
            linear-gradient(to right, white 1px, transparent 1px),
            linear-gradient(to bottom, white 1px, transparent 1px)
          `,
      backgroundSize: "40px 40px"
    }} aria-hidden="true" />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-accent/20 rounded-full blur-[120px] pointer-events-none" />

      <div className="relative container mx-auto px-6 md:px-12 flex flex-col items-center text-center z-10">
        <span className="inline-block px-4 py-1.5 mb-6 text-xs font-mono tracking-widest uppercase text-accent bg-accent/10 rounded-full">votre opération EST en auvergne-rhöne-alpes, PACA ou BOURGOGNE-FRANCHE-COMTé</span>
        
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold font-sans text-white mb-8 tracking-tight max-w-4xl">
          Prêt à professionnaliser vos opérations de livraison ?
        </h2>
        
        <p className="text-lg md:text-xl text-white/80 font-sans max-w-2xl mb-12 leading-relaxed">
          Une expertise éprouvée depuis 2008 pour accompagner les promoteurs immobiliers avec rigueur, 
          flexibilité et une qualité de service irréprochable.
        </p>

        <div className="flex flex-col sm:flex-row gap-6">
          <Button asChild size="lg" className="group relative h-14 px-10 bg-accent text-accent-foreground font-sans font-semibold text-base rounded-lg shadow-lg hover:shadow-accent/20 hover:scale-[1.03] transition-all duration-300">
            <Link to="/ContactPage">
              <span className="relative z-10 flex items-center gap-3">
                Confiez-nous vos livraisons
                <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="h-14 px-10 border-white/20 text-white hover:bg-white/10 hover:text-white rounded-lg font-sans font-medium">
            <Link to="/AMODeliveriesPage">
              Découvrir nos services
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}